import { List } from 'antd';
import styled from 'styled-components';

const Item = styled(List.Item)`
  padding: 0.5rem 1rem;
  background: #fff;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .ant-list-item-meta {
    align-items: center;
  }
`;

export default Item;
